import React, { useContext, useEffect } from "react";
import { Modal, useTranslator } from "@sia/style-guide";
import { TopSection } from "@sia/style-guide/dist/components/SIA-WEBSITE/Section/Section";
import SurveyEmployeesSection from "pages/SurveyPage/SectionContent/EmployeesSection/SurveyEmployeesSection";
import SurveyOverheadsSection from "pages/SurveyPage/SectionContent/OverheadsSection/SurveyOverheadsSection";
import "./SectionContent.scss";
import { DataCollectionContext } from "contexts/DataCollectionContext";
import { useSurveySectionStructure } from "./useSurveyStructure";
import GlobalContext from "contexts/GlobalContext";
import { useSurveyFormSession } from "../SurveyFormSessionContext";

/* eslint-disable react/prop-types */
const SurveySectionContent = () => {
  const { employees, finishDataCollection, isSubmitModalOpen, setIsSubmitModalOpen } = useContext(DataCollectionContext);
  const { menuItems, setMenuItems } = useContext(GlobalContext);
  const translate = useTranslator();

  const {
    selectedSurveyTab,
    requestSurveyTabChange,
    topSectionHistory,
    overheadsForm,
    employeeActions,
    handleEmployeeCancel,
    handleRequestOpenEmployeeForm,
    handleRequestOpenFileUpload,
  } = useSurveyFormSession();

  const sectionStructure = useSurveySectionStructure(translate, overheadsForm.isOverheadsComplete, employees.length > 0);
  const element = sectionStructure.page_section_element[selectedSurveyTab];

  useEffect(() => {
    const originalMenuItems = [...menuItems];
    const fullUrlMenuItems = menuItems.map((item, index) => {
      const SUPPORT_LINKS_INDEX = 2;
      if (index === SUPPORT_LINKS_INDEX) {
        return { ...item, children: item.children.map((e) => ({ ...e, to: `${process.env.REACT_APP_BENCHMARKING_URL}${e.to}` })) };
      }
      return item;
    });
    // @ts-ignore
    setMenuItems(fullUrlMenuItems);
    // @ts-ignore
    return () => setMenuItems(originalMenuItems);
  }, []);

  const SubmitSurveyModal = () =>
    isSubmitModalOpen ? (
      <Modal
        title={translate("benchmarking.survey.submit")}
        lead={translate("benchmarking.survey.submit.modal.lead")}
        cancelLabel={translate("modal.button.cancel")}
        onCancel={() => setIsSubmitModalOpen(false)}
        confirmLabel={translate("modal.button.confirm")}
        onConfirm={() => {
          finishDataCollection();
          setIsSubmitModalOpen(false);
        }}
      />
    ) : null;

  return (
    <>
      <div className="section-container sia-padding-02-bottom">
        <div className="section-content">
          <TopSection
            item={sectionStructure}
            array={sectionStructure.page_section_element}
            selected={selectedSurveyTab}
            setSelected={(idx) => requestSurveyTabChange(idx, sectionStructure.page_section_element[idx])}
            history={topSectionHistory}
            stopNavigation={true}
          />
        </div>
      </div>
      <SubmitSurveyModal />
      {element.segment === "companyOverhead" && (
        <SurveyOverheadsSection
          items={overheadsForm.items}
          fieldsByKey={overheadsForm.fieldsByKey}
          undoOwnerFieldKey={overheadsForm.undoOwnerFieldKey}
          badge={overheadsForm.badge}
          feedbackClock={overheadsForm.feedbackClock}
          progress={overheadsForm.progress}
          parentChildrenTotalErrors={overheadsForm.parentChildrenTotalErrors}
          onFieldChange={overheadsForm.changeField}
          onFieldBlur={overheadsForm.blurField}
          onFieldAction={overheadsForm.activateFieldAction}
        />
      )}
      {element.segment === "employees" && (
        <SurveyEmployeesSection
          employeeActions={employeeActions}
          onEmployeeCancel={handleEmployeeCancel}
          onRequestOpenEmployeeForm={handleRequestOpenEmployeeForm}
          onRequestOpenFileUpload={handleRequestOpenFileUpload}
        />
      )}
    </>
  );
};

export default SurveySectionContent;
